<template>
    <div style="padding-bottom: 50px;">


        <!--hallo das ist ja cool {{this.header}}-->
        <kendo-grid :data-source="this.preparedData"
                    :pageable-always-visible="true"
                    :pageable-page-size="10">
            <kendo-grid-column :field="'value'"
                               :title="this.header"
                               :width="40"></kendo-grid-column>
        </kendo-grid>
        Gewählte Zuordnung: {{ dropdownlistValue }}
        <br />
        <kendo-dropdownlist ref="dropdownlistFieldName"
                            v-model="dropdownlistValue"
                            :data-source="dataSourceArray"
                            :data-text-field="'name'"
                            :data-value-field="'value'"
                            :filter="'contains'"
                            @change="onChange"
                            @select="onSelect"
                            @databound="onFieldNameDataBound"
        >
        </kendo-dropdownlist>
    </div>
</template>

<script>
    export default {
        name: "importcol-grid",
        props: ['user','header','colwisedata','formfields'],
        data: function () {
            return {
                preparedData: undefined,
                fieldsAdded: false,
                dropdownlistValue: this.header,
                dataSourceArray: [
                    { name: 'Feld ignorieren', value: '-1' },
                    //{ name: this.header, value: this.header },

                    //{ name: 'Feld neu anlegen', value: 'create' },
                ]
            }
        },
        watch: {
            formfields: function(newValue, oldValue) {
                console.log("formfields changed", newValue, oldValue);

                if(!this.fieldsAdded){
                    this.buildFieldSelector();
                }
            },
        },
        mounted () {

            this.init();

        },
        methods:{
            init: function(){
                //console.log("importcol-grid mounted!", this.header, this.colwisedata);
                //console.log("jeder header", this.header);





                var dataset = [];

                for(var colData in this.colwisedata){
                    for (var prop in this.colwisedata[colData]) {
                        if(this.colwisedata[colData].hasOwnProperty( prop ) ) {
                            //console.log("o." + prop + " = " + colWiseData[colData][prop]);
                            if(this.header == prop && prop != undefined && prop != "" && prop != null){
                                //console.log("gefunden", this.header, " -- ", prop," -- " , this.colwisedata[colData][prop]);
                                var tmpEntry = {
                                    name: prop,
                                    value: "-"
                                };
                                if(this.colwisedata[colData][prop] != null && this.colwisedata[colData][prop] != undefined){
                                    tmpEntry = {
                                        name: prop,
                                        value: this.colwisedata[colData][prop]
                                    };
                                }
                                dataset.push(tmpEntry);
                            }
                        }
                    }
                }
                //console.log("dataset: ", dataset);
                //console.log("root dataset davor: ", this.$root.sharedState.importdata.prepared);
                this.$root.sharedState.importdata.prepared = dataset;
                //console.log("root dataset danach: ", this.$root.sharedState.importdata.prepared);
                //console.log("mainVueData", this.$root.sharedState);

                this.preparedData = dataset;
            },
            buildFieldSelector: function(){
                this.fieldsAdded = true;
                var vi = this;

                // region Zunächst die verfügbaren Standardfelder einfügen

                // Nummer
                vi.dataSourceArray.push({
                    name: 'Nummer',
                    value: 'db_number'
                });

                // Nummer
                vi.dataSourceArray.push({
                    name: 'Inventarnummer',
                    value: 'db_inventory_number'
                });

                // Name
                vi.dataSourceArray.push({
                    name: 'Name',
                    value: 'db_name'
                });

                // Beschreibung
                vi.dataSourceArray.push({
                    name: 'Beschreibung',
                    value: 'db_desc'
                });

                // Kategorie
                vi.dataSourceArray.push({
                    name: 'Kategorie',
                    value: 'db_category'
                });

                // Standort
                vi.dataSourceArray.push({
                    name: 'Standort',
                    value: 'db_location'
                });

                // Notiz
                vi.dataSourceArray.push({
                    name: 'Notiz',
                    value: 'db_note'
                });

                // endregion

                // region Dann alle verfügbaren Feldtypen der verwendeten Formularfelddefinition einfügen
                $.each(this.formfields['field_type'], function(idx, elem) {
                    console.log("buildFieldSelector",idx,elem);


                    vi.dataSourceArray.push({
                        name: elem.name,
                        value: elem.configuration.model
                    });
                });

                // endregion
            },
            onFieldNameDataBound: function(){
                // Erforderlich, da sonst der gesetzte Wert nicht übernommen wird
                // Siehe: https://www.telerik.com/forums/dropdownlist-default-value-not-passed-to-controller
                let dropdown = this.$refs.dropdownlistFieldName.kendoWidget();
                dropdown.trigger('change');
            },
            onSelect: function(e) {
                console.log("Event :: select",e);
                this.$emit('change', {
                    header: this.header,
                    name: e.dataItem.name,
                    value: e.dataItem.value
                })
            },
            onChange: function(e) {
                //console.log("Event :: change",e);
                //this.$emit('change', {
                    //header: this.header,
                    // todo: Warum ist Name hier nicht vorhanden? name: e.dataItem.name,
                    //name: e.dataItem.name,
                    //value: e.dataItem.value
                //})
            },

        },

    }
</script>

<style scoped>

</style>
